import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-meter",
  "use": "dv-meter-usage",
  "viewBox": "0 0 14.25 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.25 20\" id=\"dv-meter\"><title>dv-meter</title><g id=\"dv-meter_Page-1\"><g id=\"dv-meter_solarman-v003\"><g id=\"dv-meter_Group-21\"><path id=\"dv-meter_Combined-Shape\" d=\"M3.72,0H16.28a.85.85,0,0,1,.85.85v18.3a.85.85,0,0,1-.85.85H3.72a.85.85,0,0,1-.85-.85V.85A.85.85,0,0,1,3.72,0ZM9.65,14.33v0a0,0,0,0,0,0,0l2.48-3.07h-2v-2a0,0,0,0,0,0,0L7.63,12.39h2ZM6.19,3a.85.85,0,0,0-.85.85V6.33a.85.85,0,0,0,.85.85h7.52a.85.85,0,0,0,.85-.85V3.87A.85.85,0,0,0,13.71,3ZM9.83,17.53a.62.62,0,1,0-.62-.62A.62.62,0,0,0,9.83,17.53Zm-2.11,0a.62.62,0,1,0-.62-.62A.62.62,0,0,0,7.71,17.53Zm4.22,0a.62.62,0,1,0-.62-.62A.62.62,0,0,0,11.94,17.53Z\" transform=\"translate(-2.87)\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-meter.svg
// module id = yeUM
// module chunks = 268